import z from "zod";

const translationPath = "page.4uDlist.generationRule.individual.errors.";

const sexSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "sex" },
);

const ageSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "age" },
);

export const individualSchema = z.object({
  id: z.string().optional(),
  sex: sexSchema,
  age: ageSchema,
});

export type TIndividualForm = z.infer<typeof individualSchema>;
